<!--applicant details-->
<div class="col-12 pb-3">
  <div class="row">
    <div class="col col-12">
      <h1 class="d-inline">Charge quote application form</h1>
      <span class="ml-2">If you require assistance, email <a href="mailto:bcfpayments@bct.nsw.gov.au">bcfpayments@bct.nsw.gov.au</a></span>
      <p>
        <br/>Use this form to request a quote for making a payment into the Biodiversity Conservation Fund. A Proponent may make this payment as an alternative to the retirement of credits to offset biodiversity impacts (refer to Section 6.30 (1) of the Biodiversity Conservation Act, 2016). under Division 6, Section 6.30 (1) of the Biodiversity Conservation Act, 2016
      </p>
    </div>
  </div>

  <div class="card">
    <div data-toggle="collapse" class="pointer" data-target="#applicantDetailsDiv" role="button" aria-expanded="false"
         aria-controls="applicantDetailsDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
      <h4 class="card-header accordion-up">
        A. Development proponent Details<span class="pull-right mr-3">
          <i class="fa fa-arrow-up icon-info" aria-hidden="true">
          </i>
        </span>
      </h4>
    </div>
    <div class="card-body" id="applicantDetailsDiv">
      <div class="row">
        <div class="col-6 pr-2">
          <form [formGroup]="applicantFg" novalidate>
            <div class="row">
              <div class="form-group col col-12">
                <label class="control-label required" for="name">Proponent name</label>
                <span class="p-2"><tooltip register="QuoteRegister" tab="RFQ" section="Applicant Details" field="Applicant Name"></tooltip></span>

                <input id="name" formControlName="name" type="text" title="Proponent name" maxlength="100" class="form-control col-sm-8" placeholder="Proponent name" aria-required="true" />
                <div *ngIf="applicantFg.controls['name'].hasError('required')" class="text-danger">
                  Please enter proponent name.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-12">
                <label class="control-label required" for="applicantType">Proponent type</label>
                <select class="col-sm-8 form-control" formControlName="applicantType">
                  <option value="">Select proponent type</option>
                  <option value="BUS">Business</option>
                  <option value="IND">Individual</option>
                  <option value="LGOV">Local Government</option>
                  <option value="PART">Partnership</option>
                  <option value="SGOV">State Government</option>
                  <option value="TST">Trust</option>
                </select>
                <div *ngIf="applicantFg.controls['applicantType'].hasError('required')" class="text-danger">
                  Please select proponent type.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-12">
                <label class="control-label" for="name">ABN</label>
                <input id="name" formControlName="abn" type="text" title="ABN number" maxlength="15" class="form-control col-sm-8" placeholder="ABN" aria-required="true" />
                <div *ngIf="applicantFg.controls['abn'].hasError('invalidAbn')" class="text-danger">
                  {{ applicantFg.controls['abn'].errors?.invalidAbn || 'ABN, ACN or ARBN is required.' }}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-4 pl-2">
          <app-mailing-address #mailingAddress [skipCountry]="true" [title]="'Proponent\'s Mailing address'" [tooltipContext]="mailingAddressTooltipContext"></app-mailing-address>
        </div>
      </div>

    </div>

  </div>

  <!--Contact details-->
  <div class="card mt-2">
    <h4 class="card-header accordion-up" role="button">
      B. Contact details<span class="pull-right mr-3">
        <i class="fa fa-arrow-up icon-info" aria-hidden="true"></i>
      </span>
    </h4>
    <div class="card-body">
      <div class="row">
        <div class="col-6"><app-contact-details #primaryContact [title]="'Primary contact'" [validate]="true" [isRequired]="true" [tooltipContext]="primaryContactTooltipContext"></app-contact-details></div>
        <div class="col-6"><app-contact-details #secondaryContact [title]="'Secondary contact'" [validate]="false" [tooltipContext]="secondaryContactTooltipContext"></app-contact-details></div>

      </div>
    </div>
    <div class="col-12 pl-0" *ngIf="appicationId >0 && !isDraft">

      <div class="col-12" >
        <app-user-access-list [quoteId]="appicationId"
                              height="350px"
                           >
        </app-user-access-list>
      </div>
    </div>
    <!--Development details-->
    <div class="card mt-2">
      <h4 class="card-header accordion-up" role="button">
        C. Development details<span class="pull-right mr-3">
          <i class="fa fa-arrow-up icon-info" aria-hidden="true"></i>
        </span>
      </h4>
      <div class="card-body">
        <form [formGroup]="developmentFg" novalidate>
          <div class="row">
            <div class="form-group col col-6">
              <label class="control-label required" for="developmentName">Development name</label>
              <span class="p-2"><tooltip register="QuoteRegister" tab="RFQ" section="Development Details" field="Development name"></tooltip></span>

              <input id="name" formControlName="developmentName" type="text" title="Development name" maxlength="100" class="form-control col-sm-6" placeholder="Development name" aria-required="true" />
              <div *ngIf="developmentFg.controls['developmentName'].invalid && (developmentFg.controls['developmentName'].dirty || developmentFg.controls['developmentName'].touched)" class="text-danger">
                <small>Development name is required.</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col col-6">
              <label class="control-label required" for="developmentTypeId">Development type</label>
              <span class="p-2"><tooltip register="QuoteRegister" tab="RFQ" section="Development Details" field="Development type"></tooltip></span>
              <select class="col-sm-6 form-control" formControlName="developmentTypeId">
                <option value="">Select a development type</option>
                <option *ngFor="let devType of developmentTypes" value="{{devType.id}}">{{devType.name}}</option>
              </select>
              <div *ngIf="developmentFg.controls['developmentTypeId'].invalid && (developmentFg.controls['developmentTypeId'].dirty || developmentFg.controls['developmentTypeId'].touched)" class="text-danger">
                <small>Development type is required.</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col col-6">
              <label class="control-label required" for="lga">Local Government Area</label>
              <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Development Details" field="Local Government Area"></tooltip></span>
              <div style="display: flex;" class="align-items-center">
                <select class="col-sm-6 form-control" formControlName="lga">
                  <option value="">Select a Local Government Area</option>
                  <option *ngFor="let lga of lgas" value="{{lga.id}}">{{lga.name}}</option>
                </select>
              </div>
              <!--get the data from API--><div>


              </div>

              <div *ngIf="developmentFg.controls['lga'].invalid && (developmentFg.controls['lga'].dirty || developmentFg.controls['lga'].touched)" class="text-danger">
                <small>Local government area type is required.</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col col-6">
              <label class="control-label required" for="obligationType">NSW statutory approval type </label>
              <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Development Details" field="Offset statutory obligation type"></tooltip></span>
              <select class="col-sm-6 form-control" formControlName="obligationType">
                <option value="">Select a statutory approval type</option>
                <option *ngFor="let oblType of obligationTypes" value="{{oblType.code}}">{{oblType.name}}</option>
              </select>
              <div *ngIf="developmentFg.controls['obligationType'].invalid && (developmentFg.controls['obligationType'].dirty || developmentFg.controls['obligationType'].touched)" class="text-danger">
                <small>NSW statutory approval type is required.</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col col-6">
              <label class="control-label" for="obligationReference">NSW statutory approval no.</label>
              <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Development Details" field="NSW Statutary obligation reference"></tooltip></span>
              <input id="name" formControlName="obligationReference" type="text" title="NSW Statutory obligation reference" maxlength="50" class="form-control col-sm-6" placeholder="NSW Statutory obligation reference" aria-required="true" />
            </div>
          </div>
          <div class="row">
            <div class="form-group col col-6">
              <label class="control-label" for="cwObligationReference">Commonwealth statutory approval no. (if relevant)</label>
              <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Development Details" field="Commonwealth Statutary obligation reference"></tooltip></span>
              <input id="name" formControlName="cwObligationReference" type="text" title="Commonwealth Statutory obligation reference" maxlength="50" class="form-control col-sm-6" placeholder="Commonwealth Statutory obligation reference" aria-required="true" />
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer">
        <div *ngIf="applicantFg.status=='INVALID' || !isValidPrimaryContact || developmentFg.status=='INVALID'" class="alert alert-danger">
          <ul>
            <li *ngIf="applicantFg.status=='INVALID'">Please complete all the mandatory fields (*) in proponent details section</li>
            <li *ngIf="!isValidPrimaryContact">Please complete all the mandatory fields (*) in primary contact details section</li>
            <li *ngIf="developmentFg.status=='INVALID'">Please complete all the mandatory fields (*) in development details section</li>
          </ul>
        </div>
        <button *ngIf="isDraft" class="btn btn-primary" (click)="saveDraft();" [disabled]="!validApplication">Save draft</button>
        <span *ngIf="isDraft" class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Button" field="Save Draft"></tooltip></span>
        <button *ngIf="isDraft" class="btn btn-secondary ml-3" (click)="deleteDraft();" [disabled]="!allowDelete">Delete draft <i class="fa fa-trash" aria-hidden="true"></i></button>
        <button *ngIf="!isDraft" class="btn btn-primary" (click)="Update();" [disabled]="!validApplication">Update</button>
        <span *ngIf="!isDraft" class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Button" field="Update"></tooltip></span>
 
      </div>
    </div>

    <!--Obligation details-->
    <div class="card mt-2">
      <h4 class="card-header accordion-up" role="button">
        D. Biodiversity credit obligations<span class="pull-right mr-3">
          <i class="fa fa-arrow-up icon-info" aria-hidden="true"></i>
        </span>
      </h4>
      <div class="card-body">
        <div class="row" *ngIf="appicationId<=0">
          <div class="col text-danger mb-1">Please save the application as draft before adding any obligations.</div>
        </div>
        <div class="row mb-2">
          <div class="col"><button class="btn btn-primary" [disabled]="appicationId<=0" (click)="openModal();">Add Obligation</button>
          <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Biodiversity credit obligations" field="Add Obligation"></tooltip></span>
          </div>
        </div>
        <ag-grid-angular style="width: 100%;height:350px"
                         class="ag-theme-alpine"
                         [rowData]="obligations"
                         [columnDefs]="creditColumnDefs"
                         [pagination]="true"
                         [defaultColDef]="defaultColDef"
                         (cellClicked)="EditObligation($event);"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>
        <app-credit #creditModal (added)="obligationAdded($event);" (updated)="obligationUpdated($event);"></app-credit>
        <!--<app-alert-model #deleteConfirmModal></app-alert-model>-->
      </div>
    </div>

    <!--Supporting info-->
    <div class="card mt-2">
      <h4 class="card-header accordion-up" role="button">
        E. Supporting information<span class="pull-right mr-3">
          <i class="fa fa-arrow-up icon-info" aria-hidden="true"></i>
        </span>
      </h4>
      <div class="card-body">
        <div class="col-md-10">
          <p>Save the application as draft before uploading any documents.</p>
          <Form [formGroup]="filesFg" novalidate>
            <h5 class="required">Either</h5>
            <div class="row">
              <div class="form-group col-md-12">
                <label class="control-label">Evidence of submitted NSW development application (or similar)</label>
                <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Supporting Information" field="Evidence of submitted NSW development application"></tooltip></span><br />

                <span>Evidence from a NSW statutory approval authority</span>
                <div class="input-group">
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #nsw1FileName readonly maxlength="100" />
                  <button class="btn btn-primary ml-3" id="nsw1Button" type="button" (click)="nsw1FileInput.click()">Select File</button>
                </div>
                <input
                  type="file"
                  #nsw1FileInput
                  formControlName="nsw1"
                  maxlength="100"
                  style="display:none"
                  (change)="nsw1FileName.value = nsw1FileInput.files[0]?.name; fileSelected($event, 1); uploadFile(1)"
                />
                <div *ngIf="filesFg.controls['nsw1'].hasError('maxlength')" class="text-danger">
                  File name exceeds max length of 100 characters.
                </div>
                <div *ngIf="isDocumentUploaded(1)"><a href="javascript:void(0)" (click)="downloadFile(1)">{{getDocumentName(1)}}</a></div>
              </div>

            </div>

            <h5 class="mt-2">Or</h5>
            <div class="row">
              <div class="form-group col-md-12">
                <label class="control-label">NSW statutory approval with offset conditions</label>
                <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Supporting Information" field="NSW statutory approval with offset conditions"></tooltip></span>
                <br />
                <span>NSW statutory approval, including all conditions of approval relating to the credit retirement obligation </span>
                <div class="input-group">
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #nsw2FileName readonly maxlength="100" />
                  <button class="btn btn-primary ml-3" id="nsw2Button" type="button" (click)="nsw2FileInput.click()">Select File</button>
                </div>
                <input
                  type="file"
                  #nsw2FileInput
                  formControlName="nsw2"
                  maxlength="100"
                  style="display:none"
                  (change)="nsw2FileName.value = nsw2FileInput.files[0]?.name; fileSelected($event, 2); uploadFile(2)"
                />
                <div *ngIf="filesFg.controls['nsw2'].hasError('maxlength')" class="text-danger">
                  File name exceeds max length of 100 characters.
                </div>
                <div *ngIf="isDocumentUploaded(2)"><a href="javascript:void(0)" (click)="downloadFile(2)">{{getDocumentName(2)}}</a></div>
              </div>
            </div>
            <h5>And</h5>
            <div class="row">
              <div class="form-group col-md-12">
                <label class="control-label">Commonwealth statutory consent with offset conditions (if applicable)</label>
                <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Supporting Information" field="Commonwealth statutory consent with offset conditions"></tooltip></span>
                <br />
                <span>Commonwealth EPBC Act controlled action approval including all conditions of approval relating to the offset obligation(s)</span>
                <div class="input-group">
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #cwFileName readonly maxlength="100" />
                  <button class="btn btn-primary ml-3" id="cwButton" type="button" (click)="cwFileInput.click()">Select File</button>
                </div>
                <input
                  type="file"
                  #cwFileInput
                  formControlName="cw"
                  maxlength="100"
                  style="display:none"
                  (change)="cwFileName.value = cwFileInput.files[0]?.name; fileSelected($event, 3); uploadFile(3)"
                />
                <div *ngIf="filesFg.controls['cw'].hasError('maxlength')" class="text-danger">
                  File name exceeds max length of 100 characters.
                </div>
                <div *ngIf="isDocumentUploaded(3)"><a href="javascript:void(0)" (click)="downloadFile(3)">{{getDocumentName(3)}}</a></div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label class="control-label required">Credit report</label>
                <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Supporting Information" field="Credit report"></tooltip></span>
                <br />
                <span>Credit report from the Biodiversity Assessment Method (BAM) Credit Calculator</span>
                <div class="input-group">
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #crFileName readonly maxlength="100" />
                  <button class="btn btn-primary ml-3" id="crButton" type="button" (click)="crFileInput.click()">Select File</button>
                </div>
                <input
                  type="file"
                  #crFileInput
                  formControlName="cr"
                  maxlength="100"
                  style="display:none"
                  (change)="crFileName.value = crFileInput.files[0]?.name; fileSelected($event, 4); uploadFile(4)"
                />
                <div *ngIf="filesFg.controls['cr'].hasError('required') && !isDocumentUploaded(4)" class="text-danger">
                  Credit report is required.
                </div>
                <div *ngIf="filesFg.controls['cr'].hasError('maxlength')" class="text-danger">
                  File name exceeds max length of 100 characters.
                </div>
                <div *ngIf="isDocumentUploaded(4)"><a href="javascript:void(0)" (click)="downloadFile(4)">{{getDocumentName(4)}}</a></div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label class="control-label">Equivalence statement (if applicable)</label>
                <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Supporting Information" field="Equivalence statement"></tooltip></span>
                <br />
                <span>Statement of assessment of reasonable equivalence of biodiversity credits (if applicable) </span>
                <div class="input-group">
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #esFileName readonly maxlength="100" />
                  <button class="btn btn-primary ml-3" id="esButton" type="button" (click)="esFileInput.click()">Select File</button>
                </div>
                <input
                  type="file"
                  #esFileInput
                  formControlName="es"
                  maxlength="100"
                  style="display:none"
                  (change)="esFileName.value = esFileInput.files[0]?.name; fileSelected($event, 5); uploadFile(5)"
                />
                <div *ngIf="filesFg.controls['es'].hasError('maxlength')" class="text-danger">
                  File name exceeds max length of 100 characters.
                </div>
                <div *ngIf="isDocumentUploaded(5)"><a href="javascript:void(0)" (click)="downloadFile(5)">{{getDocumentName(5)}}</a></div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>

    <!--Notes and Disclaimers-->
    <div class="card mt-2">
      <h4 class="card-header accordion-up" role="button">
        F. Notes and Disclaimers<span class="pull-right mr-3"><i class="fa fa-arrow-up icon-info" aria-hidden="true"></i></span>
      </h4>
      <div class="card-body">
        <div class="row">
          <div class="col col-12">
            <p>
              The Quote will not be generated until all supporting information (Section E) is provided.
              <br />
              The BCT will provide a quote in the following timeframes:
              <br />
              Small Projects (less than 50 credits in total): 10 working days from the date that the BCT receives a completed application.
              <br />
              Large Projects (50 or more credits in total): 30 working days from the date that the BCT receives a completed application.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!--Declaration-->
    <div class="card mt-2">
      <h4 class="card-header accordion-up" role="button">
        G. Declaration<span class="pull-right mr-3"><i class="fa fa-arrow-up icon-info" aria-hidden="true"></i></span>
      </h4>
      <div class="card-body">
        <div class="row">
          <div class="col col-12">
            <p>
              I/We:
            </p>
            <ul>
              <li>Apply to receive a quote from the Biodiversity Conservation Fund (BCF) Charge System to satisfy the requirement to retire biodiversity credits in accordance with section 6.30 of the BC Act and/or satisfy a Commonwealth EPBC Act offset obligation;</li>
              <li>
                Declare that, where the proponent is an organization or comprises of more than one entity, I have authority to complete this form on behalf of the organization or, if more than one entity, on behalf of all entities;
              </li>
              <li>Declare that the information in this application form (including any attachments) is accurate and up to date to the best of my/our knowledge;</li>
              <li>Understand and acknowledge that it is an offence under section 13.10 of the BC Act to provide information in connection with a matter under this Act (or under Part 5A of the Local Land Services Act 2013 (NSW)) that a person knows, or ought to know, is false or misleading in a material particular. It is also an offence under section 307B of the Crimes Act 1900 (NSW) for a person to give information to a public authority, knowing the information is false or misleading or omits any matter or thing without which the information is misleading.</li>
            </ul>
            <p>I agree and acknowledge that:</p>
            <ul>
              <li>I give permission for the BCT to collect, store and use personal information contained in this application in accordance with the attached privacy notice and for the purpose of assessing the application.</li>
              <li>I give permission for the BCT to access, store and use any information that is held by the Department of Climate Change, Energy, the Environment and Water (DCCEEW) and the BCT, in accordance with the attached privacy notice and for the purpose of assessing the application. This includes information to verify the attributes of the offset obligation credits that are the subject of this application.</li>

            </ul>
            <div class="form-group col">
              <label class="d-flex align-items-center" style="margin-left: 0; padding-left: 0;">
                <input type="checkbox" (change)="consentChanged($event,1);" style="width: 16px; height: 16px; margin-right: 10px; flex-shrink: 0;" />  
                <span class="required">I consent to the above agreements and acknowledgements (box to be checked to indicate consent).</span>
              </label>
            </div>

            <ul>
              <li>I give permission for the BCT to publish personal information contained in this application in accordance with the attached privacy notice, including for the purpose of publicly reporting on the offset obligations satisfied by the BCT. This may include publishing the name of the proponent, name of the development, statutory offsetting obligation reference, date of payment (determined when paid) and amount of payment on the BCT’s website.</li>
            </ul>
            <div class="form-group col">
              <label class="d-flex align-items-center" style="margin-left: 0; padding-left: 0;">
                <input type="checkbox" (change)="consentChanged($event,2);" style="width: 16px; height: 16px; margin-right: 10px; flex-shrink: 0;" />
                <span class="required">I consent to the above agreement (box to be checked to indicate consent).</span>
              </label>
            </div>
            <div class="col-12">
              <p>
                If the proponent is an organisation or comprises of more than one entity, then a person who has authority should complete this declaration and submit the application on behalf of the organisation or other entities.
              </p>
            </div>
            <div class="col-6">
              <form [formGroup]="authFg">
                <div class="row">
                  <div class="col form-group form-inline">
                    <label class="control-label col-sm-3 required">Name</label>
                    <input type="text" maxlength="50" formControlName="name" class="form-control col-sm-8" />
                  </div>
                </div>
                <div class="row">
                  <div class="col form-group form-inline">
                    <label class="control-label col-sm-3 required" for="organisation">Organisation</label>
                    <input type="text" maxlength="50" formControlName="organisation" class="form-control col-sm-8" />
                  </div>
                </div>
                <div class="row">
                  <div class="col form-group" style="margin-left:25%;">
                    <input type="radio" value="self" id="authOption" name="authOption" formControlName="authOption" />&nbsp;<strong>I am the proponent</strong><br />
                    <input type="radio" value="autho" id="authOption" name="authOption" formControlName="authOption" />&nbsp;<strong>I am authorised to complete this form and submit it on behalf of the proponent</strong>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showSubmit" class="card mt-1">
      <div class="card-footer">
        <div *ngIf="!allowSubmit" class="alert alert-danger">
          <ul>
            <li *ngIf="applicantFg.status=='INVALID'">Please check all mandatory fields in proponent details section</li>
            <li *ngIf="!isValidPrimaryContact">Please check all mandatory fields in primary contact details section</li>
            <li *ngIf="developmentFg.status=='INVALID'">Please check all mandatory fields in development details section</li>
            <li *ngIf="fileNSW1 == null && fileNSW2 == null && !isDocumentUploaded(1) && !isDocumentUploaded(2)">Please upload either Evidence of submitted NSW development application or NSW statutory approval with offset conditions</li>
            <li *ngIf="filesFg.controls['cr'].hasError('required') && !isDocumentUploaded(4)">Please upload credit report</li>
            <li *ngIf="filesFg.controls['cr'].hasError('maxLength')">Credit report exceeds max length of 100 characters.</li>
            <li *ngIf="!authFg.valid">Please check all mandatory fields in declaration section</li>
            <li *ngIf="!consent1">Please tick the checkbox - I consent to the above agreements and acknowledgements</li>
            <li *ngIf="!consent2">Please tick the checkbox - I consent to the above agreement</li>
            <li *ngIf="obligations==null || obligations?.length<=0">Please add obligations</li>
          </ul>
        </div>
        <button class="btn btn-primary" [disabled]="!allowSubmit" (click)="submit();">Submit request for quote</button>
        <span class="ml-2"><tooltip register="QuoteRegister" tab="RFQ" section="Button" field="Submit request for quote"></tooltip></span>
      </div>
    </div>
  </div>
